import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Navigation from "./Navigation";
import ReactGA from "react-ga";
import {
  getLicenses,
  isAuthorized,
  isStaff,
} from "../services/license.service";

function PrivateOutlet() {
  const menuItemsForUnLicensed = ["home", "offline"];

  const location = useLocation();
  const navigate = useNavigate();

  function preventUnAuthorizedAccess(pathname: string) {
    const userId = localStorage.getItem("userId");
    const bearer = localStorage.getItem("bearer");
    const auth = userId && bearer ? true : false;
    if (auth === false) {
      return navigate("/login");
    }
    const isPublicPage = menuItemsForUnLicensed.find(
      (menu) => `/${menu}` === pathname
    );
    if (isAuthorized() === false && !isPublicPage) {
      return navigate("/home");
    }
    const licenses = getLicenses();
    if (
      pathname === `/analytics` &&
      isAuthorized() &&
      isStaff(licenses) === false
    ) {
      return navigate("/home");
    }
  }

  useEffect(() => {
    ReactGA.pageview(`${location.pathname}${location.search}`);
    preventUnAuthorizedAccess(location.pathname);
  }, [location.pathname]);

  return (
    <div className="container-xxl">
      <div className="row g-0">
        <div className="col-12 col-lg-3">
          <Navigation />
        </div>
        <div className="col-12 col-lg-9">
          <div className="content-container p-4">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivateOutlet;
